// 兼容旧代码：历史上大量页面从 ../utils/http 引入 axios 实例。
// 统一改为复用 ../api/http 的动态 baseURL（支持登录页“服务器设置（高级）”持久化）。
import api from '../api/http';

export default api;
